import i18next from 'i18next';
import { LANGUAGES } from 'src/shared/constants/languages';

export function getLocale(): string {
  return i18next.language || LANGUAGES.ru;
}
